import { render, staticRenderFns } from "./E3NewsDetail.vue?vue&type=template&id=6e1b9a7c&"
import script from "./E3NewsDetail.vue?vue&type=script&lang=js&"
export * from "./E3NewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports